import { useEffect, useState } from 'react';
import { getBranchOffices } from 'services/filters';
import { BranchOffices } from 'types';

type SelectProps = {
	id: string;
	value: string;
};

const clearState = {
	id: '',
	value: '',
};

const useBranchOfficeSelect = () => {
	const [branchOfficeOptions, setBranchOfficeOptions] = useState<SelectProps[]>(
		[],
	);
	const [selectedBranchOffice, setSelectedBranchOffice] =
		useState<SelectProps>(clearState);
	const [isLoadingBranchOffice, setLoadingBranchOffice] =
		useState<boolean>(false);

	const fetchBranchOfficeOptions = async (): Promise<void> => {
		setLoadingBranchOffice(true);
		try {
			const res = await getBranchOffices();
			const branchOffices = res.data.content.branchOffices;
			const formattedBranchOffices = branchOffices.map(
				(branchOffice: BranchOffices) => ({
					id: branchOffice.id,
					value: branchOffice.name,
				}),
			);
			setBranchOfficeOptions([clearState, ...formattedBranchOffices]);
		} catch (error) {
			console.error(error);
		} finally {
			setLoadingBranchOffice(false);
		}
	};

	const handleSelectBranchOffice = (selected: any) => {
		setSelectedBranchOffice(selected);
	};

	useEffect(() => {
		fetchBranchOfficeOptions();
	}, []);

	return {
		branchOfficeOptions,
		selectedBranchOffice,
		handleSelectBranchOffice,
		isLoadingBranchOffice,
	};
};

export default useBranchOfficeSelect;
